"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsSimpleTreeView = void 0;
var _SimpleTreeView = require("@mui/x-tree-view/SimpleTreeView");
var _TreeItem = require("@mui/x-tree-view/TreeItem");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsSimpleTreeView component
 * 
 * This component renders a simple tree view using the provided data.
 *
 * @param {Object} props - The component props
 * @param {Array} props.data - An array of dictionaries representing the tree nodes. Each dictionary should have the following structure:
 * @param {string} props.data[].id - The unique identifier for the node.
 * @param {string} props.data[].name - The display name for the node.
 * @param {Function} props.data[].callBack - The callback function to be executed when the node is clicked.
 * @param {Array} [props.data[].children] - An optional array of child nodes, each following the same structure as the parent node.
 * 
 * @example
 * const data = [
 *   {
 *     id: '1',
 *     name: 'Node 1',
 *     callBack: () => console.log('Node 1 clicked'),
 *     children: [
 *       {
 *         id: '1-1',
 *         name: 'Node 1-1',
 *         callBack: () => console.log('Node 1-1 clicked'),
 *       },
 *       {
 *         id: '1-2',
 *         name: 'Node 1-2',
 *         callBack: () => console.log('Node 1-2 clicked'),
 *       },
 *     ],
 *   },
 * ];
 * 
 * <DmsSimpleTreeView data={data} />
 */
const DmsSimpleTreeView = _ref => {
  let {
    data
  } = _ref;
  const renderTreeItems = items => {
    return items.map(item => /*#__PURE__*/_react.default.createElement(_TreeItem.TreeItem, {
      key: item.id,
      itemId: item.id,
      label: item.name,
      onClick: item.callBack
    }, item.children && renderTreeItems(item.children)));
  };
  return /*#__PURE__*/_react.default.createElement(_SimpleTreeView.SimpleTreeView, null, renderTreeItems(data));
};
exports.DmsSimpleTreeView = DmsSimpleTreeView;